import { SESSION_TYPE_NAMES } from 'common/src/config';
import { If, PreImg } from 'common/src/components';
import { Tag } from '@umu/umu-design';
import { lang } from '@umu/ukit-lang';
import { classSet } from '@umu/umu-dom';
import React, { useState } from 'react';
import { isInMobile } from '@umu/umu-ua';
import './floatingLayerForContentBaseOfUmuNormal.scss';
import iconTime from '@umu/umu-search/src/common/images/icon-time.png';
import recomd from '@umu/umu-search/src/common/images/icon-recommend.png';
import { computerHightlight } from '@umu/umu-search/src/common/utils/utils';
import {
    IAppHistorySearch,
    IAppHistoryCourse,
    ELEMENT_TYPE,
    IAppLenovoCourseExtends,
    IAppSearchData,
    OBJ_TYPE as SEARCH_OBJ_TYPE,
} from '@umu/umu-types';
import { searchObjLabelMap } from '@umu/umu-search/src/searchInputForContent/common/dataflow';
import { ICallBack, IAppPopular, IAppLenovoElement } from '@umu/umu-search/src/searchInputForContent/common/interface';

interface IProps {
    className?: string;
    panelType?: string;
    showType?: string;
    historySearch?: IAppHistorySearch[];
    popular?: IAppPopular[];
    historyCourse?: IAppHistoryCourse[];
    LenovoCourse?: IAppLenovoElement[];
    cleanCallback(): void;
    clickCallback(data: IAppSearchData, key: string): void;
}

const BubbleCard = ({ data, callBack }: { data: IAppHistorySearch[]; callBack: ICallBack }) => {
    return (
        <div className="float-layer-bubble-card float-row">
            {data &&
                data.map((items: IAppHistorySearch, index: number) => (
                    <span
                        key={'bubble-' + index}
                        className="bubble-span"
                        onClick={() => {
                            callBack(items, 'bubble');
                        }}
                    >
                        <span className="bubble-text">{items.keyword || ''}</span>
                    </span>
                ))}
        </div>
    );
};

const PopularIcon = ({ items }: { items: IAppPopular }) => {
    if (items.type === 'recomd') {
        return (
            <PreImg>
                <img className="popular-img" src={recomd} />
            </PreImg>
        );
    }

    return <span className="popular-recomd">{items.num || ''}</span>;
};

const ObjLabel = ({ data }: { data: IAppPopular }) => {
    const objType = (data.obj_type as unknown as SEARCH_OBJ_TYPE) || SEARCH_OBJ_TYPE.group;
    let label = searchObjLabelMap[objType].label || '';
    if (data.session_type && objType === SEARCH_OBJ_TYPE.element) {
        label = SESSION_TYPE_NAMES[data.session_type as ELEMENT_TYPE];
    }
    return (
        <div className="label-div">
            <Tag className="lenovo-label">{label}</Tag>
        </div>
    );
};

const SearchCourseLabel = ({ data }: { data: IAppLenovoElement }) => {
    const objType = (data.obj_type as unknown as SEARCH_OBJ_TYPE) || SEARCH_OBJ_TYPE.group;
    let lable = searchObjLabelMap[objType].label || '';
    if (data.session_type && objType === SEARCH_OBJ_TYPE.element) {
        lable = SESSION_TYPE_NAMES[data.session_type as ELEMENT_TYPE];
    }
    return (
        <div className="label-div">
            <Tag className="lenovo-label">{lable}</Tag>
        </div>
    );
};

const PopularCard = ({ data, callBack }: { data: IAppPopular[]; callBack: ICallBack }) => {
    return (
        <div className="float-layer-popular">
            {data &&
                data.map((items: IAppPopular, index: number) => {
                    return (
                        <div
                            key={'popular-' + index}
                            className="popular float-row"
                            onTouchStart={onTouchStart}
                            onMouseOver={onTouchStart}
                            onClick={() => {
                                callBack(items as IAppSearchData, 'popular');
                            }}
                        >
                            <PopularIcon items={items} />
                            <div className="popular-views">
                                <ObjLabel data={items} />
                                <span className="popular-text">{items.title || ''}</span>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

const onTouchStart = () => {
    console.log('onTouchStart');
};
const onTextComputerHightlight = (text: string, rate: number = 1) => {
    return computerHightlight({
        width: 500 * rate,
        unitWidth: 15,
        hightlight: text,
    });
};
interface IComputerTextProps {
    label: string;
    list: { title: string }[];
    className?: string;
}
const ComputerText = (props: IComputerTextProps) => {
    const { label, list, className } = props;
    if (list.length === 0) {
        return null;
    }
    const initText = list.map((item: any) => item.title).join(lang('，'));
    return (
        <p className={`circle-text ${className}`}>
            <span>{label}</span>
            <span
                className="truncate-text-1"
                dangerouslySetInnerHTML={{ __html: onTextComputerHightlight(initText) }}
            ></span>
        </p>
    );
};
interface IComputerTagsProps {
    list: { name: string }[];
    className?: string;
}
const ComputerTags = (props: IComputerTagsProps) => {
    const { list, className = '' } = props;
    if (list.length === 0) {
        return null;
    }

    return (
        <ul className={`circle-tags-list ${className}`}>
            {list.map((item: any, index) => {
                return (
                    <li key={`tag-${item.id}-${index}`} className="circle-tags-info">
                        <p
                            dangerouslySetInnerHTML={{ __html: `#${onTextComputerHightlight(item.name)}` }}
                            className="circle-content-row1"
                        />
                    </li>
                );
            })}
        </ul>
    );
};

const ShowContent = ({ extendsData, isPc }: { extendsData: IAppLenovoCourseExtends; isPc: boolean }) => {
    const {
        topic_content,
        course_list = [],
        link_list = [],
        tag_list = [],
    } = extendsData || {
        topic_content: '',
        course_list: [],
        link_list: [],
        tag_list: [],
    };
    const tagList = (tag_list || []).slice(0, isPc ? 10 : 4);

    return (
        <div>
            {topic_content && (
                <p
                    dangerouslySetInnerHTML={{ __html: onTextComputerHightlight(topic_content, 2) }}
                    className="truncate-text-1"
                ></p>
            )}
            <ComputerText
                label={lang('分享课程：')}
                list={course_list}
                className={classSet({
                    'margin-top-8': topic_content !== '',
                    'truncate-text-1': true,
                })}
            />
            <ComputerText
                label={lang('分享链接：')}
                list={link_list}
                className={classSet({
                    'margin-top-8': topic_content !== '' || course_list.length > 0,
                    'truncate-text-1': true,
                })}
            />
            <ComputerTags list={tagList} />
        </div>
    );
};
const SugTitle = ({ data, objType }: { data: any; objType: string }) => {
    const isPc = objType === 'pc';
    const { title, access_code = '', obj_type, extends: extendsData, element_ai_contents = '' } = data;
    const isCircle = obj_type === SEARCH_OBJ_TYPE.circle;

    const isElement = obj_type === SEARCH_OBJ_TYPE.element;
    const isShowAiSummary = isElement && !!element_ai_contents;

    if (isCircle && !!extendsData) {
        return (
            <div className="lenovo-content">
                <ShowContent extendsData={extendsData} isPc={isPc} />
            </div>
        );
    }

    return (
        <div className="lenovo-content">
            <span
                className={isPc ? 'lenovo-text' : 'truncate-text-2'}
                dangerouslySetInnerHTML={{ __html: onTextComputerHightlight(title) }}
            />
            <If condition={!!access_code}>
                <span className="lenovo-code">{`${lang('访问码：')} ${access_code}`}</span>
            </If>
            <If condition={isShowAiSummary}>
                <div className="lenovo-ai-summary-container">
                    <i className="icon-star"></i>
                    <span
                        className="lenovo-code lenovo-ai-summary truncate-text-2"
                        dangerouslySetInnerHTML={{ __html: `...${onTextComputerHightlight(element_ai_contents)}` }}
                    />
                </div>
            </If>
        </div>
    );
};

const LenovoCard = ({ data, callBack, types }: { data: IAppLenovoElement[]; callBack: ICallBack; types: string }) => {
    let floatClass = 'float-layer-lenovo';
    floatClass += types === 'phone' ? ' float-lenovo-mobile' : '';

    return (
        <div className={floatClass}>
            {data &&
                data.map((items: IAppLenovoElement, index: number) => {
                    let className = types === 'phone' ? 'lenovo lenovo-mobile' : 'lenovo lenovo-pc';
                    className += index + 1 === data.length ? ' lenovo-list-last' : '';
                    return (
                        <div
                            key={'lenovo-' + index}
                            className={className}
                            onClick={() => {
                                callBack(Object.assign({}, items, { num: index }), 'lenovo');
                            }}
                        >
                            <SearchCourseLabel data={items} />
                            <SugTitle data={items} objType={types} />
                        </div>
                    );
                })}
        </div>
    );
};

const HistoryCourseCard = ({ data, callBack }: { data: IAppHistoryCourse[]; callBack: ICallBack }) => {
    return (
        <div className="float-layer-course">
            {data &&
                data.map((items: IAppHistoryCourse, index: number) => {
                    return (
                        <div
                            key={'course-' + index}
                            className="course float-row"
                            onTouchStart={onTouchStart}
                            onMouseOver={onTouchStart}
                            onClick={() => {
                                callBack(Object.assign({}, items, { num: index }), 'course');
                            }}
                        >
                            <PreImg>
                                <img className="course-img" src={iconTime} />
                            </PreImg>
                            <span className="course-text">{items.title || ''}</span>
                        </div>
                    );
                })}
        </div>
    );
};

const MoreText = ({ types }: { types: string }) => {
    if (types === 'pc') {
        return (
            <div className="float-row pc-more">
                <i className="more-icon-pc" />
                <span className="popular-more-text-pc">{lang('查看更多')}</span>
            </div>
        );
    }
    if (types === 'phone') {
        return (
            <div className="phone-text">
                <span className="popular-more-text">{lang('查看更多')}</span>
                <i className="more-icon-phone" />
            </div>
        );
    }
    return <div />;
};

const CleanText = ({ types, callBack }: { types: string; callBack: () => void }) => {
    if (types === 'pc') {
        return (
            <div className="float-layer-clear" onClick={callBack}>
                <i className="float-layer-clear-icon" />
                <span>{lang('清空')}</span>
            </div>
        );
    }
    if (types === 'phone') {
        return (
            <div className="float-layer-clear" onClick={callBack}>
                <i className="float-phone-clear-icon" />
            </div>
        );
    }

    return <div />;
};

const BorderBottom = () => {
    return <div className="border-bottom-span float-row" />;
};

const getPopularData = (data: IAppPopular[], showMore: boolean) => {
    if (showMore) {
        return data;
    }

    const len = data.length > 5 ? 5 : data.length;
    const res = [];
    for (let i = 0; i < len; i++) {
        res.push(data[i]);
    }
    return res;
};

export const FloatingLayerForContentBaseOfUmuNormal = (props: IProps) => {
    const {
        className,
        showType,
        historySearch = [],
        popular = [],
        historyCourse = [],
        LenovoCourse = [],
        panelType = 'pc',
    } = props;
    const [showMore, setShowMore] = useState(false);

    let classNameFloat = 'float-layer-title float-row';
    if (isInMobile()) {
        classNameFloat += ' float-title-phone';
    }

    return (
        <div className={`search-input-for-content__umu-normal__float-layer ${className}`}>
            <If condition={!!(showType && showType === 'history')}>
                <div className="float-layer__panel">
                    <If condition={!!(historySearch && historySearch.length > 0)}>
                        <div>
                            <div className="float-layer-bubble-div float-layer-bubble-div__search-history">
                                <div className={classNameFloat}>
                                    <span>{lang('历史搜索')}</span>
                                    <CleanText types={panelType} callBack={props.cleanCallback} />
                                </div>
                                <BubbleCard data={historySearch} callBack={props.clickCallback} />
                            </div>
                            <If
                                condition={
                                    panelType === 'pc' &&
                                    (!!(popular && popular.length > 0) || !!(historyCourse && historyCourse.length > 0))
                                }
                            >
                                <div style={{ paddingBottom: '0.12rem' }}>
                                    <BorderBottom />
                                </div>
                            </If>
                        </div>
                    </If>
                    <If condition={!!(popular && popular.length > 0)}>
                        <div className="float-layer-popular-div">
                            <div className={'popular-title ' + classNameFloat}>
                                <span>{lang('热门内容')}</span>
                            </div>
                            <PopularCard data={getPopularData(popular, showMore)} callBack={props.clickCallback} />
                            {
                                <If condition={!!(popular && popular.length > 5 && !showMore)}>
                                    <div
                                        className="popular-more"
                                        onClick={() => {
                                            setShowMore(true);
                                        }}
                                    >
                                        <MoreText types={panelType} />
                                    </div>
                                </If>
                            }
                            <If condition={panelType === 'pc' && !!(historyCourse && historyCourse.length > 0)}>
                                <BorderBottom />
                            </If>
                        </div>
                    </If>
                    <If condition={!!(historyCourse && historyCourse.length > 0)}>
                        <div className="float-layer-course-div">
                            <div className={'course-title ' + classNameFloat}>
                                <span>{lang('最近在学')}</span>
                            </div>
                            <HistoryCourseCard data={historyCourse} callBack={props.clickCallback} />
                        </div>
                    </If>
                </div>
            </If>
            <If condition={!!(showType && showType === 'lenovo' && LenovoCourse && LenovoCourse.length > 0)}>
                <LenovoCard data={LenovoCourse} callBack={props.clickCallback} types={panelType} />
            </If>
        </div>
    );
};
